// 検索系 API のアクセス失敗 (HTTP エラー / ネットワークエラー) を
// グローバルに保持し、画面上に "Server Error" を表示するための State。
// PWA でオフライン化しているため、API 失敗を 0 件と区別して明示する目的。
import type { ServerErrorInfo } from "~/utils/cWebCatalogApi";

export const useApiErrorState = () => {
  // undefined のときはエラーなし。値があるときに "Server Error" を表示する。
  const state = useState<ServerErrorInfo | undefined>("apiServerError", () => undefined);

  const setServerError = (error: ServerErrorInfo) => {
    state.value = error;
  };

  const clear = () => {
    state.value = undefined;
  };

  return { state, setServerError, clear };
};
